import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import paytomLogo from "../../assests/images/logo.png";
import klikpayLogo from "../../assests/images/klikpaylogo.png";
import QRBonPayLogo from "../../assests/images/banqo.jpg";
import leopaylogo from "../../assests/images/leopay.jpg";
import "./login.css";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import TextField from "../../Helper/TextField";
import { useDispatch, useSelector } from "react-redux";
import { AUTH_LOGIN } from "../../redux/auth/types";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";

import forgotPasswordService from "../../services/forgotPasswordService";
import { LEOPAY_TITLE_NAME } from "../../utils/Constant";

const ForgetPassword = () => {
  const title = process.env.REACT_APP_TITLE;
  const userIp = useSelector((state) => state.userIpAddReducer.ip);
  const userId = useSelector(
    (state) => state.getprofilereducer?.getprofile?.id
  );
  const [loginLoading, setLoginLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const getUniqId = () => uuidv4().replace(/-/g, "").toUpperCase();
  const unique_id = getUniqId();

  const primaryColor =
    title === "KlikPay Merchant Portal"
      ? process.env.REACT_APP_PRIMARY_COLOR_KLIKPAY
      : title === "QRBonPay Merchant Portal"
      ? process.env.REACT_APP_PRIMARY_COLOR_QRBonPay
      : title === LEOPAY_TITLE_NAME
      ? process.env.REACT_APP_PRIMARY_COLOR_leopay
      : process.env.REACT_APP_PRIMARY_COLOR_PAYTOM;

  const logo =
    title === "KlikPay Merchant Portal"
      ? klikpayLogo
      : title === "QRBonPay Merchant Portal"
      ? QRBonPayLogo
      : title == LEOPAY_TITLE_NAME
      ? leopaylogo
      : paytomLogo;

  //oldPassword: "", newPassword : "", reEnterNewPassword: ""
  const forgotPasswordValidationSchema = Yup.object({
    // id: Yup.string().min(10, "Min value 10.").required("User Id Is Required"),
    oldPassword: Yup.string()
      .min(4, "Password must be at least 4 characters")
      .required("Password Is Required"),
    newPassword: Yup.string()
      .min(4, "Password must be at least 4 characters")
      .required("Password Is Required"),
    reEnterNewPassword: Yup.string()
      .min(4, "Password must be at least 4 characters")
      .required("Password Is Required"),
  });

  const sessionId = useSelector(
    (state) => state.getprofilereducer?.getprofile?.sessionId
  );
  const reqId = useSelector(
    (state) => state.getprofilereducer?.getprofile?.requestId
  );

  const e = JSON.parse(sessionStorage.getItem("token"));
  const headers = {
    Authorization: `Bearer ${e}`,
    "client-id": sessionId,
    "request-id": reqId,
  };
  const onSubmitForgotPassword = (values) => {
    console.log("called1");
    values = { ...values, headers, userId, userIp };
    forgotPasswordService(values);
  };
  const backToDashBord = () => {
    navigate("/dashboard");
  };
  return (
    <div className="login-container">
      <div className="container-fluid">
        <div className="row justify-content-center">
          <div className="col-12 col-sm-8 col-md-6 col-lg-5 col-xl-4">
            <div className="login-box">
              <div className="login-head">
                {/* {title !== LEOPAY_TITLE_NAME && ( */}
                <img
                  style={{ borderRadius: "20px", backgroundColor: "#333333" }}
                  src={logo}
                  alt="logo"
                  className="img-fluid"
                />
                {/* )} */}

                <h3
                  style={{
                    height: "100px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0",
                  }}
                >
                  Reset Your Password
                </h3>
              </div>

              <Formik
                initialValues={{
                  // id: "",
                  oldPassword: "",
                  newPassword: "",
                  reEnterNewPassword: "",
                }}
                validationSchema={forgotPasswordValidationSchema}
                onSubmit={onSubmitForgotPassword}
              >
                {() => (
                  <div className="forgot-password-form">
                    <Form>
                      {/* <div className="form-floating">
                        <TextField
                          placeholder="User ID"
                          label="User ID"
                          name="id"
                          type="id"
                        />
                      </div> */}
                      <div className="form-floating">
                        <TextField
                          name="oldPassword"
                          label="Old Password"
                          placeholder="Enter Old Password"
                          type="password"
                        />
                      </div>
                      <div className="form-floating">
                        <TextField
                          name="newPassword"
                          label="New Password"
                          placeholder="New Password"
                          type="password"
                        />
                      </div>
                      <div className="form-floating">
                        <TextField
                          name="reEnterNewPassword"
                          label="Re-Enter New Password"
                          placeholder="Re-Enter New Password"
                          type="password"
                        />
                      </div>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        {loginLoading ? (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                            className="spinner-border"
                            role="status"
                          >
                            <span className="sr-only">Loading...</span>
                          </div>
                        ) : (
                          <button
                            // disabled={loginLoading}
                            style={{
                              backgroundColor: primaryColor,
                            }}
                            className="btn btn-primary"
                            type="submit"
                          >
                            Reset Password
                          </button>
                        )}
                      </div>
                    </Form>
                    <p
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "20px",
                      }}
                    >
                      <a
                        onClick={() => backToDashBord()}
                        style={{ cursor: "pointer", color: "blue" }}
                      >
                        Back to dashboard
                      </a>
                    </p>
                  </div>
                )}
              </Formik>

              <ToastContainer />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgetPassword;
